import { Link } from 'react-router-dom';
import PageMeta from '../components/PageMeta';

export default function NotFound() {
  return (
    <div className="bg-slate-950 text-white min-h-[70vh] flex items-center justify-center py-20 px-4">
      <PageMeta
        title="404 - Siden blev ikke fundet - Duus Rustfri"
        description="Siden blev desværre ikke fundet. Find vej tilbage til forsiden eller kontakt Duus Rustfri."
      />

      <div className="max-w-xl text-center space-y-6">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-slate-900 border border-slate-800 text-sky-400 text-xs font-mono font-semibold uppercase">
          Fejl 404 · Siden eksisterer ikke
        </div>

        <h1 className="text-4xl sm:text-6xl font-black tracking-tight text-white">
          Siden blev ikke fundet
        </h1>

        <p className="text-slate-400 text-base sm:text-lg leading-relaxed">
          Beklager, den side du leder efter findes desværre ikke eller er blevet flyttet. Brug linksene herunder til at komme videre.
        </p>

        <div className="pt-4 flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-3 w-full sm:w-auto">
          <Link
            to="/"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl bg-gradient-to-r from-sky-600 to-blue-700 hover:from-sky-500 hover:to-blue-600 text-white font-semibold text-sm shadow-lg transition text-center"
          >
            <i className="fa-solid fa-house text-xs" aria-hidden="true" />
            <span>Gå til forsiden</span>
          </Link>

          <Link
            to="/ydelser"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl bg-slate-900 hover:bg-slate-800 border border-slate-700 text-slate-200 font-semibold text-sm transition text-center"
          >
            <i className="fa-solid fa-layer-group text-xs" aria-hidden="true" />
            <span>Se vores ydelser</span>
          </Link>

          <Link
            to="/kontakt"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl bg-slate-900 hover:bg-slate-800 border border-slate-700 text-sky-400 font-semibold text-sm transition text-center"
          >
            <i className="fa-solid fa-envelope text-xs" aria-hidden="true" />
            <span>Kontakt os</span>
          </Link>
        </div>

        <div className="pt-8 border-t border-slate-800/80 text-xs text-slate-500">
          <p>
            Har du spørgsmål til en opgave? Ring direkte på{' '}
            <a href="tel:30271671" className="text-sky-400 hover:underline font-semibold whitespace-nowrap">
              30 27 16 71
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
